export default {
  hero: {
    title: "Basetao Spreadsheet — The Complete Guide to Products, Sellers & Resources",
    subtitle:
      "Find, compare and understand Basetao Spreadsheet resources in one place. Explore practical guides, seller information, product research, shipping costs, warehouse details, coupons, reviews, QC tips and safety guidance.",
    trust: "Independent resource · Practical guides · Updated regularly",
    dropdownLabel: "Browse a category",
    dropdownPlaceholder: "Choose a category…",
  },
  whatIs: {
    title: "What Is Basetao Spreadsheet?",
    p1: "A Basetao Spreadsheet is an organized product database that helps shoppers find and compare items available through the Basetao shopping agent. Instead of scrolling through thousands of individual listings, you can browse a single structured document that groups products by category and includes supporting details such as seller information, product references and practical notes.",
    p2: "Think of it as a map: it does not sell anything by itself, but it helps you understand what products exist, how they are grouped, and where to look next. The spreadsheet is organized around common shopping categories — shoes, hoodies, t-shirts, jackets, bags, belts and more — so you can quickly narrow your research to the type of product you actually want.",
  },
  article: {
    title: "Guides & Resources",
    subtitle: "Read clear, original guides to get the most out of the Basetao Spreadsheet.",
    cardTitle: "What Is Basetao Spreadsheet? A Beginner's Guide",
    cardDesc:
      "A complete beginner-friendly overview: what the spreadsheet is, what it contains, how to use it, and what to check before you order.",
    readMore: "Read the guide",
    viewAll: "View all guides",
    related: "Related articles",
    updated: "Updated regularly",
  },
  faq: {
    title: "Frequently Asked Questions",
    q1: "What is Basetao Spreadsheet?",
    a1: "It is an organized, category-based list of products and references that helps shoppers research items available through the Basetao shopping agent.",
    q2: "How do I use Basetao Spreadsheet?",
    a2: "Open the spreadsheet, pick a category, note the product references you want, compare seller details, then verify current prices and availability on the official platform before ordering.",
    q3: "Is Basetao legit?",
    a3: "Basetao is a well-known shopping agent, but as with any agent you should always verify sellers, products, prices and policies yourself before making a purchase decision.",
    q4: "How much does Basetao shipping cost?",
    a4: "Shipping costs depend on weight, volume, destination and the shipping method you choose. Rates change over time, so always check the current terms before ordering.",
    q5: "Does Basetao have coupons or discount codes?",
    a5: "Offers may appear from time to time, but availability and eligibility can change. Always verify that a code is still valid before you rely on it.",
  },
  ctaSection: {
    title: "Ready to Explore the Full Spreadsheet?",
    subtitle:
      "Browse the complete product catalog, compare categories and start researching products on the main website.",
    button: "Visit Main Website",
  },
};